import React, { FC } from 'react';
import { Link, useSubmit } from 'react-router-dom';

import { Button, Card, CardBody, Col, Container, FormFeedback, Input, Label, Row } from 'reactstrap';

import classnames from 'classnames';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { useDate } from '@hsp/react-hooks';

import logoImg from 'assets/images/logo.svg';
import profileImg from 'assets/images/profile-img.png';
import { IUserRegister } from 'types/user';

const RegisterPage: FC = () => {
  const formik = useFormik<IUserRegister>({
    enableReinitialize: true,
    initialValues: {
      email: '',
      password: '',
      username: '',
    },
    onSubmit: async (values) => submit({ ...values }, { method: 'post' }),
    validationSchema: Yup.object().shape({
      email: Yup.string().required('Please Enter Your Email'),
      password: Yup.string().required('Please Enter Valid Password'),
      username: Yup.string().required('Please Enter Valid Username'),
    }),
  });
  const { year } = useDate();
  const submit = useSubmit();

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link
          className="text-dark"
          to="/">
          <i className="bx bx-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col
              lg={6}
              md={8}
              xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col className="col-7">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Free Register</h5>
                        <p>Get your free Skote account now.</p>
                      </div>
                    </Col>
                    <Col className="col-5 align-self-end">
                      <img
                        alt=""
                        className="img-fluid"
                        src={profileImg}
                      />
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            alt=""
                            className="rounded-circle"
                            height="34"
                            src={logoImg}
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <form
                      className="form-horizontal"
                      onSubmit={formik.handleSubmit}>
                      <div className="mb-3">
                        <Label
                          className="form-label"
                          for="email">
                          Email
                        </Label>
                        <Input
                          autoComplete="off"
                          className={classnames('form-control', {
                            'is-invalid': formik.errors.email && formik.touched.email,
                          })}
                          name="email"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="email"
                          value={formik.values.email}
                        />
                        <FormFeedback type="invalid">{formik.errors.email}</FormFeedback>
                      </div>
                      <div className="mb-3">
                        <Label
                          className="form-label"
                          for="password">
                          Password
                        </Label>
                        <Input
                          autoComplete="off"
                          className={classnames('form-control', {
                            'is-invalid': formik.errors.password && formik.touched.password,
                          })}
                          name="password"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="password"
                        />
                        <FormFeedback type="invalid">{formik.errors.password}</FormFeedback>
                      </div>
                      <div className="mb-3">
                        <Label
                          className="form-label"
                          for="username">
                          Username
                        </Label>
                        <Input
                          autoComplete="off"
                          className={classnames('form-control', {
                            'is-invalid': formik.errors.username && formik.touched.username,
                          })}
                          name="username"
                          onBlur={formik.handleBlur}
                          onChange={formik.handleChange}
                          type="text"
                        />
                        <FormFeedback type="invalid">{formik.errors.username}</FormFeedback>
                      </div>

                      <div className="mt-4 d-grid">
                        <Button
                          block
                          color="primary"
                          type="submit">
                          Register
                        </Button>
                      </div>

                      <div className="mt-4 text-center">
                        <p className="mb-0">
                          By registering you agree to the Skote
                          <Link
                            className="text-primary"
                            to="#">
                            Terms of Use
                          </Link>
                        </p>
                      </div>
                    </form>
                    {/* <Formik
                      enableReinitialize={true}
                      initialValues={{
                        email: (state && state.email) || '',
                        password: (state && state.password) || '',
                        username: (state && state.username) || '',
                      }}
                      validationSchema={Yup.object().shape({
                        email: Yup.string().required('Please Enter Your Email'),
                        password: Yup.string().required('Please Enter Valid Password'),
                        username: Yup.string().required('Please Enter Valid Username'),
                      })}
                      onSubmit={(values) => {
                        props.registerUser(values as IUser);
                      }}>
                      {({ errors, touched }) => (
                        <Form className="form-horizontal">
                          <div className="mb-3">
                            <Label
                              for="email"
                              className="form-label">
                              Email
                            </Label>
                            <Field
                              name="email"
                              type="email"
                              className={'form-control' + (errors.email && touched.email ? ' is-invalid' : '')}
                            />
                            <ErrorMessage
                              name="email"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mb-3">
                            <Label
                              for="password"
                              className="form-label">
                              Password
                            </Label>
                            <Field
                              name="password"
                              autoComplete="true"
                              type="password"
                              className={'form-control' + (errors.password && touched.password ? ' is-invalid' : '')}
                            />
                            <ErrorMessage
                              name="password"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          <div className="mb-3">
                            <Label
                              for="username"
                              className="form-label">
                              Username
                            </Label>
                            <Field
                              name="username"
                              type="text"
                              className={'form-control' + (errors.username && touched.username ? ' is-invalid' : '')}
                            />
                            <ErrorMessage
                              name="username"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="mt-4 d-grid">
                            <button
                              className="btn btn-primary btn-block"
                              type="submit">
                              Register
                            </button>
                          </div>

                          <div className="mt-4 text-center">
                            <p className="mb-0">
                              By registering you agree to the Skote
                              <Link
                                to="#"
                                className="text-primary">
                                Terms of Use
                              </Link>
                            </p>
                          </div>
                        </Form>
                      )}
                    </Formik> */}
                  </div>
                </CardBody>
              </Card>
              <div className="mt-5 text-center">
                <p>
                  Already have an account ?
                  <Link
                    className="fw-medium text-primary"
                    to="/login">
                    Login
                  </Link>
                </p>
                <p>
                  © {year} Skote. Crafted with <i className="mdi mdi-heart text-danger" /> by Themesbrand
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RegisterPage;
